export default {
    data() {
        return {
            smilesClasses: {
                1: 'fa-frown-o text-danger',
                2: 'fa-meh-o text-warning',
                3: 'fa-smile-o text-success',
            },
        }
    },
    methods: {
        smileIconClass(satisfaction) {
            return this.smilesClasses[satisfaction]
        },
        smileStatus(satisfaction) {
            switch (satisfaction) {
                case 1:
                    return 'feed.checkin.satisfaction.dissatisfed'
                case 2:
                    return 'feed.checkin.satisfaction.neutral'
                case 3:
                    return 'feed.checkin.satisfaction.satisfed'
            }
        },
    },
}
